import { gql } from "@apollo/client";

export const removeCompanyPolicySchedule = gql`
  mutation removeCompanyPolicySchedule($_id: MongoID!) {
    companyPolicySchedule_RemoveById(_id: $_id) {
      record {
        _id
      }
    }
  }
`;
